import { Box } from '@mui/material';
import { ReactNode } from 'react';
import TooltipPopup, {
  PopupComponentType,
} from '../../../commonUI/tooltips/TooltipPopup';
import MapIconStyleWrapper from '../../MapIconStyleWrapper';

export interface MapButtonProps {
  icon: ReactNode;
  popupComponent: PopupComponentType;
}

export const MapButtonWithTooltip: React.FC<MapButtonProps> = ({
  icon,
  popupComponent,
}) => {
  return (
    <TooltipPopup popupComponent={popupComponent} colorScheme='dark'>
      {/* extra box needed to make the tooltip popup work and avoid a forward ref error */}
      <Box>
        <MapIconStyleWrapper icon={icon} />
      </Box>
    </TooltipPopup>
  );
};
